export default __webpack_public_path__ + "static/media/releaseTitle2.bdbe1e44.png";